import React from 'react';
// import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import BasePage from 'components/BasePage';
import { FlexColContainer } from 'components/StyledComp';
import Panel from 'components-desktop/Panel';
import PatientDetails from './components/profile/PatientDetails';
import PatientAbsences from './components/profile/PatientAbsences';
import PatientContracts from './components/profile/PatientContracts';
import PatientAuthorizations from './components/profile/PatientAuthorizations';
import PatientMasterweeks from './components/profile/PatientMasterweeks';
import PatientCalendar from './components/profile/PatientCalendar';

const propTypes = {
};

@autobind
class PatientProfilePage extends BasePage {
  constructor(props) {
    super(props);

    this.state = {
      patient: null,
      contracts: [],
      servicesByCompany: {},
      tabsActiveKey: props.location.hash?.substring(1) || 'details',
    };
  }

  componentDidMount() {
    this.id = this.parseQueryParam('id', this.props.location);
    this.getPatient();
    this.getPatientContracts();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.location !== prevProps.location) {
      this.setState({
        tabsActiveKey: this.props.location.hash?.substring(1) || 'details',
      });
    }
  }

  getTitle() {
    return 'Patient Profile';
  }

  async getPatient() {
    const params = { id: this.id };
    const patient = await this.callServiceForRemoteObject('/patient/get_model', params);

    this.setState({
      patient,
    });
  }

  async getPatientContracts() {
    const params = { patientId: this.id };
    const contracts = await this.callServiceForRemoteObjects('/contract/get_list', params);

    // Also get services.
    let servicesByCompany = {};
    if (contracts.length > 0) {
      const companyIds = contracts.map(c => c.getLong('companyId'));
      servicesByCompany =
          await this.callServiceForObject('/service/get_list_by_companies', { companyIds });
    }

    this.setState({
      contracts,
      servicesByCompany,
    });
  }

  onDeleteMasterweekSuccess() {
    // Refresh calender in case some visits have been deleted.
    if (this.patientCalendar) {
      this.patientCalendar.refresh();
    }
  }

  onUpdateMasterweekSuccess() {
    // Refresh calender in case some visits have been deleted.
    if (this.patientCalendar) {
      this.patientCalendar.refresh();
    }
  }

  isInRenderableState() {
    return !!this.state.patient;
  }

  renderContent() {
    const { patient, contracts, servicesByCompany, tabsActiveKey } = this.state;

    return (
      <FlexColContainer
        width="match_parent"
        height="wrap_content"
        alignItems="center"
      >
        <Panel
          width="match_parent"
          height="wrap_content"
          margin="0 0 24px 0"
          color="blue_steel"
          title={`Patient - ${patient.getString('fullName')} (${patient.getId()})`}
          icon="user"
          tabs={['Details', 'Absences', 'Contracts', 'Authorizations', 'Masterweeks', 'Calendar']}
          tabsActiveKey={tabsActiveKey}
          tabsOnChange={activeKey => this.setState({ tabsActiveKey: activeKey.substring(2) })}
        >
          <PatientDetails
            key="details"
            width="match_parent"
            height="wrap_content"
            patient={patient}
          />

          <PatientAbsences
            key="absences"
            width="match_parent"
            height="wrap_content"
          />

          <PatientContracts
            key="contracts"
            width="match_parent"
            height="wrap_content"
            patient={patient}
            contracts={contracts}
            servicesByCompany={servicesByCompany}
            getPatientContracts={this.getPatientContracts}
          />

          <PatientAuthorizations
            key="authorizations"
            width="match_parent"
            height="wrap_content"
            contracts={contracts}
            servicesByCompany={servicesByCompany}
          />

          <PatientMasterweeks
            key="masterweeks"
            width="match_parent"
            height="wrap_content"
            contracts={contracts}
            servicesByCompany={servicesByCompany}
            onDeleteMasterweekSuccess={this.onDeleteMasterweekSuccess}
            onUpdateMasterweekSuccess={this.onUpdateMasterweekSuccess}
          />

          <PatientCalendar
            key="calendar"
            width="match_parent"
            height="wrap_content"
            wrappedComponentRef={(ref) => { this.patientCalendar = ref; }}
            contracts={contracts}
            servicesByCompany={servicesByCompany}
          />
        </Panel>
      </FlexColContainer>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
PatientProfilePage.propTypes = propTypes;

export default PatientProfilePage;
